module.exports = __webpack_public_path__ + "static/chaire-30746d8ead9b94b803ed9d88aa80b94e.png";